import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Field from '../Field';
import TenantRow from '../Fragments/TenantRow';
import SubmitInput from '../Fields/SubmitInput';
import ButtonInput from '../Fields/ButtonInput';
import AddApplicantFields from '../Fragments/AddApplicantFields';
import ManualCompletion from '../Fragments/ManualCompletion';
import FullPageSpinner from '../Fragments/FullPageSpinner';
import { browserHistory } from 'react-router';

const currencyFormatter = require('currency-formatter');
let HttpService = require('../Managers/HttpService');
let tenants = [];
let Quote =  require('../Managers/Quote');

const maxRentAmountBeforeWarning = 10000;

class StartScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentNumber: 1,
            showManualWarning: false,
            totalRentAmount: 0,
            adjustedTotalRent: 0,
            isAdjustedTotalRentConstraintViolation: false,
            showStudentOnlyModal: false,
            minimumIncome: null,
            hasRentGuarantee: false,
            tenants: {},
            tenantNumber: 1,
            firstName: '',
            lastName: '',
            effectiveTitle: '',
            isProductTypeChosen: false,
            hasStudentModalAlreadyFired: false,
            isFullPageSpinnerActive: false,
            products: [],
            hashObject: {
                smsPreference: null
            }
        };

        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillMount() {
        this.setState({
            hashObject: HttpService.getDecodedAgentHash(),
        }, () => {
            if (!window.uorn(this.state.hashObject.agentMobile)) {
                Quote.setByPath('Case.agentMobile', this.state.hashObject.agentMobile);
            }
        });

        HttpService.getRetrieveProductsForAgent()
        .then(products => {
            this.setState({ products });
            window.localStorage.setItem('AgentProducts', JSON.stringify(products));
        });

        // Set all the legal texts - inject relevant ones to the footer.
        HttpService.getPublicLegalTexts()
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
            document.getElementById('mainPhone').innerHTML = Quote.getByPath('domainInfo.generalTelephone');
        })
        .catch(error => {
            throw error;
        });
    }

    componentDidMount() {
        Quote.set('propertyLetType', 2, 'Case');
        Quote.set('rentGuaranteeOfferingType', 1, 'Case');
        Quote.set('propertyBuiltInRangeType', 10, 'Case');
        Quote.set('numberOfTenants', 1, 'Case');
        Quote.set('completionMethod', 3, 'BaseIndividualApplication_1');

        if (window.uorn(JSON.parse(window.localStorage.getItem('errorArray')))) {
            $('html, body').animate({
                scrollTop: $('body').offset().top - $('header.site-header').height()
            }, 500);
        }

        // show a warning if we need one
        this.handleTotalRentWarning();
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    /**
     * find the total rent component from the start screen input components,
     * and using its current value, check if its over the max before warning. if
     * it is over, add a warning to it. otherwise, remove the warning
     * @return {void}
     */
    handleTotalRentWarning() {
        let totalRentComponent = this.inputComponents
            .filter(c => !window.uorn(c))
            .find(c => c.props.fieldName === 'totalRent');

        let totalRentAmount = totalRentComponent.getChildInstance().getCurrentValue();

        if (totalRentAmount > maxRentAmountBeforeWarning) {
            totalRentComponent.getChildInstance().setState({
                hasWarning: true,
                warnings: ["You have entered a rental value of " + currencyFormatter.format(totalRentAmount, {code: "GBP"}) + ". If this correct please continue with the application, alternatively please amend above."]
            });
        } else {
            totalRentComponent.getChildInstance().setState({
                hasWarning: false,
                warnings: []
            });
        }
    }

    /**
     * loop through all the tenants in local state and update any
     * DOM fields for them that we need to
     */
    refreshAllTenantFields() {
        let tenants = this.state.tenants;

        Object.keys(tenants).map((v, i) => {
            let index = i + 1;
            let tenant = tenants[index];
            let rentShare = tenant.rentShare;
            try {
                document.getElementById('rentShare_' + index).value = rentShare;
            } catch(err) { /* this can silently fail */ }
            try {
                document.getElementById('rentShare_' + index).value = rentShare;
            } catch(err) { /* this can silently fail */ }
        });
    }

    updateTotalRent(v) {
        this.setState({
            totalRentAmount: v,
            minimumIncome: (v * 12) * 2.5,
            adjustedTotalRent: v,
        }, () => {
            // they might now be over 10K, possibly show a warning!
            this.handleTotalRentWarning();
        });
    }

    forceStudent() {
        if (this.state.hasStudentModalAlreadyFired === false) {
            this.setState({
                showStudentOnlyModal: true,
                hasStudentModalAlreadyFired: true,
            });
        }
    }

    closeModals(e) {
        e.preventDefault();
        this.setState({ showStudentOnlyModal: false });
    }

    /**
     * build a list of all components from this screen and all child
     * screens, and run said components internal handleValidation methods
     * @return {void}
     */
    performValidation() {
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });
    }

    checkAndContinue() {
        this.setState({ isFullPageSpinnerActive: true });

        this.performValidation();

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                this.setState({ isFullPageSpinnerActive: false });
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.agentEmailToTenantProcess()
                .then(() => {
                    browserHistory.push('/case/submitted');
                })
                .catch(errorData => {
                    this.setState({ isFullPageSpinnerActive: false });
                    if (!window.uornorb(errorData) && !window.uornorb(errorData.errors)) {
                        window.localStorage.setItem('errorArray', JSON.stringify(errorData.errors));
                    }
                    browserHistory.push('/error/agent-email-to-tenant');
                });
            }
        }, 1000);

    }

    /**
     * Saves a notionally-complete Applicant object for rendering as a tenant
     * summary row.
     *
     * Increment's the current tenant number for creating a new, unique tenant
     * object.
     *
     * @param e
     */
    saveTenant(e) {
        this.setState({ tenantNumber: e + 1 });
    }

    // Callback function from child component/s when setting a new 'current'
    // number state - used to evaluate the just-completed tenant number.
    setPreviousTenantNumber(e) {
        this.setState({ currentNumber: e });
        for (let i = 0; i < e; i++) {
            tenants.push(
                <TenantRow
                    key={e}
                    currentNumber={e}
                    tenant={window.localStorage.getItem('BaseIndividualApplication' + (i + 1))}
                    //updateTenantRentShare={this.props.updateTenantRentShare.bind(this)}
                    fieldName={'tenant_' + (i + 1) + '_share'}
                    defaultShare={0}
                    source={'tenant_' + (i + 1) + '_details'}
                    //removeTenant={this.removeTenant.bind(this)}
                />
            );
        }
    }

    handleChildErrors() {
        // todo: this is where we would do something to show the errors against incomplete/incorrectly formatted fields
    }

    /**
     * Validates against the entered values and if all required fields are
     * present and correct either allows the user to add another tenant, or
     * closes the tenant details sub-form/component and loads the tenant summary
     * for review by the agent user.
     */
    completeTenantObject() {
        // Process child components to check for errors
        this.handleChildErrors(this.props.children);
        this.saveTenant(this.state.tenantNumber);
        let tenantErrors = document.querySelectorAll('#tenant-details .has-error').length;

        if (tenantErrors > 99) {
            $(document.body).animate({
                'scrollTop': $('#tenant-details .has-error').offset().top - 160
            }, 1000);
        } else {
            this.setPreviousTenantNumber(this.state.currentNumber);
        }
    }

    /**
     * Allows the user to add more tenants to the application
     */
    addMoreTenantsAction(e) {
        this.setState({ isFullPageSpinnerActive: true });

        this.performValidation();

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                this.setState({ isFullPageSpinnerActive: false });
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                this.setState({ isFullPageSpinnerActive: false });
                this.completeTenantObject(e);
                browserHistory.push('/case/add-another-tenant/' + (this.state.currentNumber + 1));
            }
        }, 1000);
    }

    completeNow() {
        this.setState({ isFullPageSpinnerActive: true });

        this.performValidation();

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                this.setState({ isFullPageSpinnerActive: false });
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.agentCompleteNowProcess()
                .then(() => {
                    browserHistory.push('/case/submitted');
                })
                .catch(() => {
                    this.setState({ isFullPageSpinnerActive: false });
                    browserHistory.push('/error/agent-complete-now');
                });
            }
        }, 1000);
    }

    render() {
        let FaCross = require('react-icons/lib/fa/close');

        return(
            <div>
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <question-row class="header-row">
                    <h1>Details of property to be let</h1>
                </question-row>

                <Field
                    fieldName="address"
                    storageKey="address"
                    question="Postcode of property to be let"
                    type="address"
                    addressOptions={{
                        canHaveManualEntry: true,
                        hasManualEntryOption: true,
                        canBeForeign: false,
                        pafLookup: true,
                    }}
                    source="Case.address"
                    loadValues={true}
                    loadingKey={'Case.address'}
                    ref={(instance) => {
                        this.inputComponents.push(instance);
                        this.childComponents.push(instance);
                    }}
                />

                <Field
                    fieldName="totalRent"
                    storageKey="totalRent"
                    question="Total property rent (per calendar month)"
                    type="money"
                    dataValidation="rent_amount"
                    callbackFunction={this.updateTotalRent.bind(this)}
                    source="Case"
                    loadValues={true}
                    loadingKey={'Case.totalRent'}
                    ref={(instance) => { this.inputComponents.push(instance); }}
                />

                {this.state.minimumIncome ?
                    <question-row class="no-border">
                        <p>Minimum income required for the household is <strong>&pound;{this.state.minimumIncome.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong><br />(subject to tenancy term and employment type)</p>
                    </question-row>
                :
                    <question-row class="no-border">
                        <p>Minimum income required for the household will be displayed upon entering a valid rental amount above.<br />(subject to tenancy term and employment type)</p>
                    </question-row>
                }

                <Field
                    fieldName="propertyType"
                    storageKey="propertyType"
                    question="What is the property type?"
                    type="button-choice"
                    dataValidation="required_field.non_mandatory"
                    options={[
                        {
                            id: 1,
                            value: 1,
                            text: 'Detached'
                        },
                        {
                            id: 2,
                            value: 2,
                            text: 'Semi-detached'
                        },
                        {
                            id: 3,
                            value: 3,
                            text: 'Flat'
                        },
                        {
                            id: 4,
                            value: 4,
                            text: 'Terraced'
                        },
                        {
                            id: 5,
                            value: 5,
                            text: 'Bungalow'
                        },
                        {
                            id: 6,
                            value: 6,
                            text: 'Other'
                        },
                    ]}
                    source="Case"
                    loadValues={true}
                    loadingKey={'Case.propertyType'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName="numberOfBedrooms"
                    storageKey="numberOfBedrooms"
                    question="How many bedrooms does the property have?"
                    type="select"
                    options={[
                        {
                            option_value: 1,
                            option_text: '1',
                        },
                        {
                            option_value: 2,
                            option_text: '2',
                        },
                        {
                            option_value: 3,
                            option_text: '3',
                        },
                        {
                            option_value: 4,
                            option_text: '4',
                        },
                        {
                            option_value: 5,
                            option_text: '5',
                        },
                        {
                            option_value: 6,
                            option_text: '6',
                        },
                        {
                            option_value: 7,
                            option_text: '7',
                        },
                        {
                            option_value: 8,
                            option_text: '8',
                        },
                        {
                            option_value: 9,
                            option_text: '9',
                        },
                        {
                            option_value: 10,
                            option_text: '10+',
                        },
                    ]}
                    dataValidation="at_least_one.non_mandatory"
                    source="Case"
                    loadValues={true}
                    loadingKey={'Case.numberOfBedrooms'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName="tenancyTerm"
                    storageKey="tenancyTerm"
                    question="Tenancy term in months"
                    type="number"
                    dataValidation="tenancy_term"
                    source="Case"
                    loadValues={true}
                    loadingKey={'Case.tenancyTerm'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <Field
                    fieldName="tenancyStartDate"
                    storageKey="tenancyStartDate"
                    question="Tenancy start date"
                    type="date"
                    subType="calendar"
                    showHelpIcon={false}
                    helpText="Tenancy start dates can be up to 6 months in the future. Keep in mind that we can only reference students if the date is more than 60 days in the future."
                    callbackFunction={this.forceStudent.bind(this)}
                    dataValidation="tenancy_start"
                    source="Case"
                    loadValues={true}
                    loadingKey={'Case.tenancyStartDate'}
                    displayTenancyMessage={false}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                <div className={this.state.showStudentOnlyModal === true ? 'modal-container modal-active' : 'modal-container'}>
                    <div className="modal medium-width has-footer">
                        <div className="modal-header">
                            Student Only
                            <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                <FaCross className="pointer" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="content">
                                <p><b>Please note:</b> by setting the tenancy start date to more than 60 days in the future, all of the tenants in the property must be students.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <ButtonInput
                                id="acceptStudentOnly"
                                buttonText="OK"
                                classNames="btn-success"
                                borderless={true}
                                unpadded={true}
                                onClickEvent={this.closeModals.bind(this)}
                            />
                        </div>
                    </div>
                </div>

                <question-row class="header-row">
                    <h2>Tenant Details</h2>
                </question-row>

                <AddApplicantFields
                    type="tenant"
                    source="BaseIndividualApplication_1"
                    currentNumber={1}
                    loadValues={true}
                    agentStep={true}
                    products={this.state.products}
                    ref={(instance) => { this.childComponents.push(instance); }}
                />

                {this.state.hashObject.smsPreference == 2 ?
                    <div>
                        <question-row class="header-row">
                        <h2>Do you want SMS updates on the application&rsquo;s progress?</h2>
                        </question-row>

                        <Field
                        hasBorder={false}
                        maxLength={11}
                        fieldName="agentMobile"
                        storageKey="agentMobile"
                        question="Enter your mobile number below to receive key agent updates on this application"
                        type="text"
                        dataValidation="mobile_number.non_mandatory"
                        source="Case"
                        ref={(instance) => {this.inputComponents.push(instance);}}
                        inputExtra={'To add additional tenants, click the <strong>"Add more Tenants"</strong> button below.'}
                        />
                    </div>
                : null }

                <SubmitInput
                    label="Email to Tenant"
                    callbackFunction={this.checkAndContinue.bind(this)}
                    backLink={false}
                    saveForLater={false}
                    hasSecondaryButton={true}
                    secondaryButtonText={'Add more tenants'}
                    secondaryButtonAction={this.addMoreTenantsAction.bind(this)}
                />

                <ManualCompletion
                    yesFunc={() => {
                        // we can only have 1 tenant cus we're on start screen
                        // and we're doing a complete now - set her to
                        // complete now
                        let tenant = JSON.parse(window.localStorage.getItem('BaseIndividualApplication_1'));
                        tenant.completionMethod = 1;
                        window.localStorage.setItem('BaseIndividualApplication_1', JSON.stringify(tenant));

                        this.completeNow();
                    }}
                />
            </div>
        );
    }
}

StartScreen.propTypes = {
    totalProvidedRentAmount:    PropTypes.array,
    currentNumber:              PropTypes.number,
    params:                     PropTypes.object,
    children:                   PropTypes.array,
};

StartScreen.defaultProps = {
    totalProvidedRentAmount: [],
};

export default StartScreen;


// WEBPACK FOOTER //
// ./src/components/Screens/StartScreen.js